import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { PERMISSIONS, hasPermission } from '../../../base/permissions';
import { getBrandingColorPalette } from '../../../base/styles';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
import abstractPollsPane from '../AbstractPollsPane';
import PollCreate from './PollCreate';
import PollsList from './PollsList';
/* eslint-enable lines-around-comment */
const useStyles = makeStyles()(() => {
    return {
        // Flex column: the list shrinks to fit so the footer stays in view.
        // A % height against a max-height-only parent resolves to auto in
        // Firefox and pushed the create button out of the pane.
        container: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100vh - 240px)'
        },
        listContainer: {
            flex: '1 1 auto',
            minHeight: 0,
            overflowY: 'auto',
            scrollbarWidth: 'thin'
        },
        footer: {
            flexShrink: 0,
            padding: '24px',
            width: '100%',
            boxSizing: 'border-box'
        }
    };
});
const PollsPane = ({ createMode, onCreate, setCreateMode, sourceFilter, t }) => {
    var _a;
    const { classes } = useStyles();
    const interfaceConfig = useSelector(state => state['features/base/config'].interfaceConfig);
    // Gate on the capability, not on the role: moderators and panelists may both
    // run polls, and a visitor-scoped list is never authored from here.
    const canCreatePoll = useSelector(state => hasPermission(state, PERMISSIONS.CREATE_POLLS))
        && sourceFilter !== 'visitor';
    const createPollStyle = {
        backgroundColor: (_a = getBrandingColorPalette(interfaceConfig)) === null || _a === void 0 ? void 0 : _a.primary
    };
    return createMode
        ? React.createElement(PollCreate, { setCreateMode: setCreateMode })
        : React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.listContainer },
                React.createElement(PollsList, { sourceFilter: sourceFilter })),
            React.createElement("div", { className: classes.footer }, canCreatePoll && (React.createElement(Button, { accessibilityLabel: t('polls.create.create'), fullWidth: true, labelKey: 'polls.create.create', onClick: onCreate, style: createPollStyle, type: BUTTON_TYPES.SECONDARY }))));
};
/*
 * We apply AbstractPollsPane to fill in the AbstractProps common
 * to both the web and native implementations.
 */
export default abstractPollsPane(PollsPane);
